import React, { useMemo } from "react";
import SideNavigation from "../../components/nav-side-menu/side-navigation";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";

const SettingsLayout = ({ children }) => {
    let { pathname } = useLocation();
    const sourceMap = useMemo(() => {
        return [
            {
                label: "Notifications",
                path: "/admin/settings/notifications",
                icon: faBell,
            },
        ];
    }, []);

    return (
        <div className="row">
            <div className="column -span2">
                <SideNavigation sourceMap={sourceMap} activePath={pathname} />
            </div>
            <div className="column -span10">{children}</div>
        </div>
    );
};

export default SettingsLayout;
